import React from 'react'

const BannerDataListPage = ({ data }) => {

    return (
        data?.paragraph?.map((item, index) => {
            return (<p key={index} className="paragraph">{item?.para}</p>)
        })
    )
}
export default BannerDataListPage
